/**
 * InitialSettingBody
 * 
 * @Author: Focci
 * @Date: 2024-02-22 10:04:15
 * @Last Modified by: Focci
 * @Last Modified time: 2024-02-22 10:04:15
 */

import useLocaleSwitch from '@hook/useLocaleSwitch'
import { LocaleSwitcherBodyItem } from '@page/common/header/location-locale/LocaleSwitcherBody'
import { cookieSet, langOpts } from '@lib/utils'
import { getCookieOption } from '@lib/get-cookie-option'
import { HG_CURRENT_COUNTRY_NAME, baseUrls } from '@lib/config'
import { useState, useCallback } from 'react'
import { defaultLocale, localCookieName, locales } from '@i18n/config'
import { Button, Dialog, DialogContent } from '@comp/material'
import { useTranslations } from 'next-intl'
import LanguageSettingItems from '../LanguageSettingItems'

export default function InitialSettingBody() {
  const tp = useTranslations('profile')
  const tc = useTranslations('common')
  const { lang, country, countryOptions, flagIcon } = useLocaleSwitch()
  const [open, setOpen] = useState(true)
  const [currentContry, setCurrentCountry] = useState(country)
  const [locale, setLocale] = useState(lang)

  const handleSwitchCountry = useCallback(({ value }) => setCurrentCountry(value), [])
  const handleLanguage = useCallback(({ value }) => setLocale(value), [])

  const handleSave = useCallback(() => {
    const option = getCookieOption()
    cookieSet(localCookieName, locale, option)
    cookieSet(HG_CURRENT_COUNTRY_NAME, currentContry, option)
    setOpen(false)
    
    // 跳转到新地址
    let url = ''
    const langSuffix = locale === defaultLocale ? '' : `/${locale}`
    
    // 如果改了国家，则跳转到首页
    if(country !== currentContry) {
      url = `${baseUrls[currentContry]}${langSuffix}`
    } else {
      const { href, pathname } = window.location
      const pns = pathname.split('/')
      const uri = new URL(href)
      const newPathname = locales.indexOf(pns[1]) > -1 ? pns.slice(2) : pns

      uri.pathname = `${langSuffix}${newPathname.join('/')}`
      
      url = uri.toString()
    }

    window.location.replace(url)
  }, [currentContry, locale, country])

  return (
    <Dialog open={open}>
      <DialogContent
        className="max-w-full mx-auto !p-2 md:!px-4" 
        style={{ width: '34rem' }} 
      >
        <div className="text-center text-f1.2 mt-4 font-medium">
          {tp('language')}
        </div>
        <div className="mt-6 flex flex-col gap-y-6 mb-6">
          <div>
            <b className="mb-2 block">{tp('selectCountry')}</b>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {countryOptions.map((opt) => (
                <LocaleSwitcherBodyItem
                  key={opt.value}
                  {...opt}
                  FlagIcon={flagIcon[opt.value]}
                  lang={lang}
                  country={currentContry}
                  onClick={handleSwitchCountry}
                />
              ))}
            </div>
          </div>
          <div className="pb-8">
            <b className="mb-2 block">{tp('selectLanguage')}</b>
            <LanguageSettingItems 
              value={locale}
              options={langOpts}
              onChange={handleLanguage}
            />
          </div>
          <div className="text-center absolute left-0 right-0 bottom-0 p-3 bg-white">
            <Button size="large" onClick={handleSave}>
              <span className="px-8">{tc('save')}</span>
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
